import React, { useEffect, useState } from "react";
import {
  MDBBtn,
  MDBModal,
  MDBInput,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import { GrStatusGood } from "react-icons/gr";
import { CiNoWaitingSign } from "react-icons/ci";
import API_BASE_URL from "../utilities/apiConfig";
import Header from "../components/Header";
import RegistrationHeader from "../components/RegistrationHeader";
import axios from "axios";
import { toast } from "react-toastify";
import convertToUnderscoreFormat from "../utilities/convertToUnderscoreFormat";
import { MdPending } from "react-icons/md";
import Loader from "../components/Loader";
import fromatDateintoDDMMMMYYYY from "../utilities/fromatDateintoDDMMMMYYYY";
import formatDateToDDMMYYYY from "../utilities/formatDateToDDMMYYYY";
import axiosInstance from "../utilities/apiConfig";
export default function RegistrationStatus() {
  const [openPopupModal, setOpenPopupModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const alphabets = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";
  const [captcha, setCaptcha] = useState("");
  const [captchaStatus, setCaptchaStatus] = useState("Captcha Generator");
  const [status, setStatus] = useState("");
  const [userInput, setUserInput] = useState("");
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [barId, setBarId] = useState("");
  const [statusCode, setStatusCode] = useState("");
  const [daysLeft, setDaysLeft] = useState("");
  const [timePeriodEndDate, setTimePeriodEndDate] = useState("");
  const [remark, setRemark] = useState("");

  const generateCaptcha = () => {
    const first = alphabets[Math.floor(Math.random() * alphabets.length)];
    const second = Math.floor(Math.random() * 10);
    const third = Math.floor(Math.random() * 10);
    const fourth = alphabets[Math.floor(Math.random() * alphabets.length)];
    const fifth = alphabets[Math.floor(Math.random() * alphabets.length)];
    const sixth = Math.floor(Math.random() * 10);
    const newCaptcha = `${first}${second}${third}${fourth}${fifth}${sixth}`;
    setCaptcha(newCaptcha);
    setUserInput("");
    setCaptchaStatus("Fill Captcha Before Submission");
    setIsCaptchaVerified(false);
  };

  const checkCaptcha = (e) => {
    e.preventDefault();
    if (userInput === captcha) {
      setCaptchaStatus("Correct!!");
      setIsCaptchaVerified(true);
      handleGetVerificationData(e);
      setUserInput("");
    } else {
      generateCaptcha();
      setCaptchaStatus("Try Again!!");
      setIsCaptchaVerified(false);
      setUserInput("");
    }
  };

  const handleGetVerificationData = async (e) => {
    e.preventDefault();
    if (barId) {
      try {
        setLoading(true);
        const formatedBarId = convertToUnderscoreFormat(barId);
        const response = await axiosInstance.get(
          `/Registration/get_registration_status/${formatedBarId}`
        );
        console.log(response.data);
        const { statusCode, status } = response.data.response;
        const { daysleftforAcceptence, acceptenceDate, remark } = response.data;

        setStatusCode(statusCode);
        setStatus(status);
        setDaysLeft(daysleftforAcceptence);
        setTimePeriodEndDate(acceptenceDate);
        setRemark(remark);

        if (statusCode === 201 || statusCode === 403 || statusCode === 404) {
          setOpenPopupModal(true);
        } else if (statusCode === 200) {
          toast.success(status);
        }
        // else if (statusCode === 404) {
        //     toast.error(status);
        // }
        else {
          toast.error(status);
        }
      } catch (error) {
        console.log(error);
      } finally {
        generateCaptcha();
        setLoading(false);
      }
    }
  };

  const getModalContent = () => {
    switch (statusCode) {
      case 201:
        return (
          <MDBModalBody>
            <p>
              <MdPending /> Pending
            </p>
            <p>Days left to complete Six-Month: {daysLeft} Days</p>
            <p>
              Six-Month completion Date:{" "}
              {formatDateToDDMMYYYY(timePeriodEndDate)}
            </p>
          </MDBModalBody>
        );
      case 403:
        return (
          <MDBModalBody>
            <p>
              <CiNoWaitingSign /> Not Accepted
            </p>
            <p> Reason : {remark}</p>
          </MDBModalBody>
        );
      case 404:
        return (
          <MDBModalBody>
            <p>
              <CiNoWaitingSign /> Not Found
            </p>
            <p>{status}</p>
          </MDBModalBody>
        );
      default:
        return (
          <MDBModalBody>
            <p>Unexpected status code. Please try again later.</p>
          </MDBModalBody>
        );
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <>
      <RegistrationHeader />
      {loading && <Loader />}
      <div className="row justify-content-center mb-2">
        <div className="col-xxl-8">
          <div className="row justify-content-center">
            <h3 className="text-center my-5">
              <b>Check Your Registration Status</b>
            </h3>
          </div>
        </div>
      </div>
      <div className="row justify-content-center align-items-center mb-2">
        <div className="col-xxl-8">
          <div className="row justify-content-center align-items-center">
            <div className="row justify-content-center mb-2 mt-3">
              <div className="col-xxl-10">
                <div className="row justify-content-center my-1">
                  <div className="col-md-4 mb-1 d-flex justify-content-center">
                    <MDBInput
                      required
                      value={barId}
                      onChange={(e) => setBarId(e.target.value)}
                      label="Enter Registration No"
                      type="text"
                      name="barId"
                      className="m-0 text-center"
                      id="barId"
                    />
                  </div>
                </div>
              </div>
              <div className="col-xxl-10">
                <div className="row justify-content-center my-1">
                  <div className="col-md-4 mb-1 d-flex justify-content-center">
                    <MDBInput
                      value={captcha}
                      id="generated-captcha"
                      type="text"
                      name="captcha"
                      className="m-0"
                    />
                  </div>
                </div>
              </div>
              <div className="col-xxl-10">
                <div className="row justify-content-center my-1">
                  <div className="col-md-4 mb-1 d-flex justify-content-center">
                    <MDBInput
                      required
                      value={userInput}
                      onChange={(e) => setUserInput(e.target.value)}
                      label="Enter Captcha"
                      type="text"
                      name="userInput"
                      className="m-0 text-center"
                      id="userInput"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-10">
              <div className="row justify-content-center mt-1">
                <div className="col-md-4 mb-1 d-flex justify-content-center">
                  <p
                    className="text-center"
                    id="captchaStatus"
                    style={{ color: "#ee7e6a" }}
                  >
                    {captchaStatus}
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center mb-2 mt-3">
              <div className="col-xxl-10">
                <div className="row justify-content-center my-1">
                  <div className="col-md-4 mb-1 d-flex justify-content-center">
                    <MDBBtn onClick={checkCaptcha}>Fetch Status</MDBBtn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MDBModal
        tabIndex="-1"
        open={openPopupModal}
        onClose={() => setOpenPopupModal(false)}
      >
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Registration Status</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={() => setOpenPopupModal(false)}
              ></MDBBtn>
            </MDBModalHeader>
            {getModalContent()}
            <MDBModalFooter>
              <MDBBtn onClick={() => setOpenPopupModal(false)}>OK</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
